import { CaseReducer, PayloadAction } from "@reduxjs/toolkit";
import { ProductListState, StartEditingPayload } from "./types";

const setFilterValue: CaseReducer<ProductListState, PayloadAction<string>> = (
  state,
  action
) => {
  return {
    ...state,
    filterValue: action.payload,
  };
};

const clearFilterValue: CaseReducer<ProductListState> = (state) => {
  return {
    ...state,
    filterValue: "",
  };
};

const startEditing: CaseReducer<
  ProductListState,
  PayloadAction<StartEditingPayload>
> = (state, action): ProductListState => ({
  ...state,
  ...action.payload,
});

const stopEditing: CaseReducer<ProductListState> = (
  state
): ProductListState => ({
  ...state,
  editingColumnId: undefined,
  rowIdsToEdit: undefined,
  originalCellValue: undefined,
});

const reducers = {
  setFilterValue,
  startEditing,
  stopEditing,
  clearFilterValue,
};

export default reducers;
